import { signOut } from 'next-auth/react';
import getConfig from 'next/config';
import {
  CHARACTER_VALIDATION_REGEX,
  EMAIL_VALIDATION_REGEX,
  NUMBER_VALIDATION_REGEX,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_VALIDATION_REGEX,
} from 'modules/auth/utils/constants/auth.constants';

const { publicRuntimeConfig } = getConfig();

export const isEmailValid = (value: string): boolean => {
  return EMAIL_VALIDATION_REGEX.test(value);
};

export const isPasswordValid = (value: string): boolean => {
  return PASSWORD_VALIDATION_REGEX.test(value);
};

export const isPasswordContainNumber = (value: string): boolean => {
  return NUMBER_VALIDATION_REGEX.test(value);
};

export const isPasswordContainCharacter = (value: string): boolean => {
  return CHARACTER_VALIDATION_REGEX.test(value);
};

export const isPasswordLengthValid = (password: string): boolean => {
  return password.length >= PASSWORD_MIN_LENGTH && password.length <= PASSWORD_MAX_LENGTH;
};

export const handleLogout = async (): Promise<void> => {
  sessionStorage.clear();
  await signOut({ callbackUrl: `${publicRuntimeConfig.hostUrl}` });
};
